import groupCardsData from '../data/groups.json';

export const getGroupList = () => {
  console.log("Getting group list");
  return new Promise((resolve) => {
    resolve(groupCardsData);
  });
};

export const getGroupCards = () => {
  console.log("Getting group cards");
  return new Promise((resolve) => {
    resolve(groupCardsData);
  });
};